export default __webpack_public_path__ + "fonts/10de7b9b78bdb2a191bc2085b7a16625.ttf";